import { render } from "./help-actions-main-video.vue?vue&type=template&id=d770d60e"
import script from "./help-actions-main-video.vue?vue&type=script&lang=js"
export * from "./help-actions-main-video.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miqrositio/miqrositio_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__